'use client';

export default function SiteHeaderContent({ children, name = '' }) {
  return <div className={`SiteHeader__content ${name}`}>{children}</div>;
}
